import React, { Component } from 'react';
import { Button, Card, CardActions, CardContent, CardHeader, Icon, IconButton } from '@material-ui/core';
import TableWithoutPagination from '../Table/TableWithoutPagination';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { loadAffair, loadAffairs } from '../../redux/affair/affairActions';

class ContractsAndAffairs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            columns: [
                {
                    columns: [
                        {
                            Header: "Numéro",
                            width: 100,
                            id: 'code',
                            accessor: "code",
                        },
                        {
                            Header: "Description",
                            id: 'name',
                            accessor: "name",
                        },
                    ]
                },
            ]
        }

        this.props.loadAffairs(this.props.activeUser, this.props.sites.selectedSite, this.props.sites.sites, this.props.affairs, this.props.tableState.nbTotalResults);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.sites.selectedSite !== this.props.sites.selectedSite)
            this.props.loadAffairs(this.props.activeUser, this.props.sites.selectedSite, this.props.sites.sites, this.props.affairs, this.props.tableState.nbTotalResults);
    }

    goToAffairs(e) {
        this.props.history.push("/affairs");
        e.stopPropagation();
    }

    loadAffair(e, affair) {
        this.props.loadAffair(affair);
        this.props.history.push("/affairs/affair");
        this.props.globalContainer.current.scrollTop = 0

        e.stopPropagation();
    }

    getTableTrProps(state, rowInfo) {
        if (rowInfo && rowInfo.row) {
            return {
                onClick: e => this.loadAffair(e, rowInfo.row._original),
                style: {
                    cursor: 'pointer'
                },
            }
        } else {
            return {}
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={this.props.className}>
                <Card className="card without-padding full-height" onClick={this.goToAffairs.bind(this)}>
                    <CardHeader title={"Mes contrats et affaires"} titleTypographyProps={{ variant: "h6", color: 'primary' }}
                        avatar={<Icon className={classes.iconStyle}>folder</Icon>}
                        action={
                            <IconButton color="inherit" onClick={this.props.close} aria-label="Close">
                                <Icon>close</Icon>
                            </IconButton>
                        }
                    />
                    <CardContent className="without-padding">
                        <TableWithoutPagination
                            data={this.props.affairs.filteredAndSortedAffairs}
                            columns={this.state.columns}
                            pageSize={3}
                            minRows={3}
                            sortable={false}
                            getTrProps={this.getTableTrProps.bind(this)}
                        />
                    </CardContent>
                    <CardActions className={classes.cardActions} disableSpacing>
                        <Button variant="contained" size="small" color="secondary" onClick={this.goToAffairs.bind(this)}
                            startIcon={<Icon>arrow_forward</Icon>} className={classes.smallButton}>
                            Voir plus
                    </Button>
                    </CardActions>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        affairs: state.affairs,
        activeUser: state.activeUser,
        sites: state.sites,
        tableState: state.tableState,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadAffairs: (user, customerSiteId, allSites, affairsFilters, nbTotalResults) =>
            dispatch(loadAffairs(user, customerSiteId, allSites, affairsFilters, nbTotalResults)),
        loadAffair: (affair) => dispatch(loadAffair(affair)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ContractsAndAffairs);
